var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenInPhMenuDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 2.59998H6.4C5.4 2.59998 4.5 3.39998 4.5 4.49998V19.5C4.5 20 4.7 20.5 5 20.8C5.3 21.2 5.8 21.3 6.3 21.3H17.6C18.1 21.3 18.6 21.1 18.9 20.8C19.2 20.4 19.4 20 19.4 19.5V8.19998L13.9 2.59998ZM12.9 9.19998V3.99998L18.1 9.19998H12.9Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8004 12.2V18.9L13.8004 16.9L11.1004 19.5L8.40039 16.9L11.1004 14.2L9.10039 12.2H15.8004Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInPhMenuDisable);
export default __webpack_public_path__ + "static/media/open-in-ph-menu-disable.ffa3b3ca5b659ee2e2dd227a5c7bcf65.svg";
export { ForwardRef as ReactComponent };